import { useState, useEffect, useContext } from "react";
import * as S from "../style";
import { Grid, Box } from "@mui/material";
import { projectType } from "utils/utils";
import moment from "moment";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { IoArrowUp, IoArrowDown } from "react-icons/io5";
import { getProjectBudget } from "utils/requests/project";
import { useParams } from "react-router-dom";
import { RiAddFill } from "react-icons/ri";
import OutboundForm from "pages/Finance/Accounting/ModalContent/Forms/Create/OutboundForm";
import Modal from "components/Modal/Modal";
import { TokenContext } from "context/TokenContext";

const BudgetForm = ({ project }) => {
  const params = useParams();
  const { decodedToken } = useContext(TokenContext);
  const role = decodedToken?.type;

  const [budgetData, setBudgetData] = useState([]);
  const [createOutboundModal, setCreateOutboundModal] = useState(false);

  const projectId = params.id;

  const fetchData = async () => {
    const data = await getProjectBudget(projectId);
    if (!data.message) {
      setBudgetData(data);
    }
  };

  useEffect(() => {
    fetchData();
  }, [projectId]);

  return (
    <Grid container flexDirection="column" gap="15px">
      <S.ProjectCard>
        <Grid container justifyContent="space-between">
          <S.FormTitleGrid container flexDirection="column" item md={5}>
            <p>Orçamento</p>
            <p className="subTitle">Gerenciar informações financeiras do projeto</p>
          </S.FormTitleGrid>
          <Grid display="flex" flexDirection="column" alignItems="flex-end" item md={7}>
            {project?.status === "ENDED" && (
              <S.FinishedProjectBadgeGrid item>
                <p>Projeto finalizado</p>
              </S.FinishedProjectBadgeGrid>
            )}
            <S.BadgeGrid item>
              <p>{projectType(project?.type)}</p>
            </S.BadgeGrid>
          </Grid>
          <S.BudgetDataGrid container>
            <Grid container item md={4} xl={4} flexDirection="column">
              <p className="budgetTitle">Saldo</p>
              <p className="budgetValue">
                R${" "}
                {Number((budgetData.currentBalance / 100).toFixed(2)).toLocaleString("pt-BR", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </p>
            </Grid>
            <Grid container item md={4} xl={4} flexDirection="column">
              <Grid container gap="5px">
                <p className="budgetTitle">Total Gasto</p>
                <IoArrowDown color="#D7007B" size="16px" style={{ alignSelf: "center" }} />
              </Grid>
              <p className="budgetValue">
                R${" "}
                {Number((budgetData.totalOutbound / 100).toFixed(2)).toLocaleString("pt-BR", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </p>
            </Grid>
            <Grid container item md={4} xl={4} flexDirection="column">
              <Grid container gap="5px">
                <p className="budgetTitle">Total de Entrada</p>
                <IoArrowUp color="#65EFAD" size="16px" style={{ alignSelf: "center" }} />
              </Grid>
              <p className="budgetValue">
                R${" "}
                {Number((budgetData.totalInbound / 100).toFixed(2)).toLocaleString("pt-BR", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </p>
            </Grid>
          </S.BudgetDataGrid>
        </Grid>
      </S.ProjectCard>
      <S.AccordionCard sx={{ maxHeight: "580px", overflow: "auto" }}>
        {!budgetData.projectFinancialData ||
          (budgetData.projectFinancialData.length === 0 && (
            <p style={{ fontSize: "20px", textAlign: "center" }}>Nenhum registro encontrado</p>
          ))}
        {budgetData.projectFinancialData &&
          budgetData.projectFinancialData.map((card) => (
            <S.CheckboxAccordion sx={{ backgroundColor: "transparent !important" }} key={card?.id}>
              <S.CheckboxAccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
                sx={{ color: "#fff" }}
              >
                {/*{card.title}*/}
                <Grid container gap="5px">
                  <p>{card?.description ?? "-"}</p>
                  {card?.type === "ENTRADA" ? (
                    <IoArrowUp color="#65EFAD" size="16px" style={{ alignSelf: "center" }} />
                  ) : (
                    <IoArrowDown color="#D7007B" size="16px" style={{ alignSelf: "center" }} />
                  )}
                </Grid>
              </S.CheckboxAccordionSummary>
              <S.CheckboxAccordionDetails sx={{ color: "#fff" }}>
                <Grid container flexDirection="column" px="30px" gap="20px">
                  <Grid container justifyContent="space-between">
                    <Grid display="flex" item lg={4} flexDirection="column">
                      <p className="subTitle">Valor (R$)</p>
                      <p className="content">
                        R${" "}
                        {Number((card?.value / 100).toFixed(2)).toLocaleString("pt-BR", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </p>
                    </Grid>
                    <Grid display="flex" item lg={4} flexDirection="column" pr="30px">
                      <p className="subTitle">Data</p>
                      <p className="content">
                        {card?.createdAt ? moment(card?.dateInvoiced).format("L") : ""}
                      </p>
                      {card?.members?.length === 0 && <p className="content">-</p>}
                    </Grid>
                    <Grid display="flex" item lg={4} flexDirection="column">
                      <p className="subTitle">Categoria</p>
                      <p className="content">{card?.category?.name ?? "-"}</p>
                    </Grid>
                  </Grid>
                  <Grid container flexDirection="column">
                    <p className="subTitle">Status</p>
                    <p
                      className={`content ${
                        card?.businessStatus === "PAGO" || card?.businessStatus === "RECEBIDO"
                          ? "positive"
                          : "negative"
                      }`}
                    >
                      {card?.businessStatus ?? "-"}
                    </p>
                  </Grid>
                  <Grid container flexDirection="column">
                    <p className="subTitle">Observação</p>
                    <p className="content">{card?.miscInfo ?? "-"}</p>
                  </Grid>
                </Grid>
              </S.CheckboxAccordionDetails>
            </S.CheckboxAccordion>
          ))}
      </S.AccordionCard>
      {(role === "ADMINISTRATOR" || role === "H_MARKETING") && (
        <Box sx={{ "& > :not(style)": { m: 1 } }}>
          <S.ModalFab color="primary" onClick={() => setCreateOutboundModal(true)}>
            <RiAddFill size="30px" />
          </S.ModalFab>
        </Box>
      )}
      <Modal open={createOutboundModal} onClose={() => setCreateOutboundModal(false)}>
        <p>Nova despesa</p>
        <OutboundForm
          refetch={fetchData}
          closeModal={() => setCreateOutboundModal(false)}
          project={project}
        />
      </Modal>
    </Grid>
  );
};

export default BudgetForm;
